import axios from 'axios'

export default {

    async getGroupActivityAssignmentsMatrixData({ group_id, sub_group_id, course_id=0, lesson_id=0 }) {
        return await axios.get(`/activity/group/assignment-matrix/${group_id}/${sub_group_id}?course_id=${course_id}&lesson_id=${lesson_id}`)
    },

    // A Holdstatistik tab as a PDF for auditors: kind is the tab's route,
    // 'assignment-matrix', 'quiz-matrix' or 'courses'. A blob, so the caller
    // can hand it to the browser as a download.
    async downloadGroupStatisticsPdf({ kind, group_id, sub_group_id, course_id=0, lesson_id=0, status='', lang='da' }) {
        const query = `course_id=${course_id}&lesson_id=${lesson_id}&status=${encodeURIComponent(status)}&lang=${encodeURIComponent(lang)}`
        return await axios.get(`/activity/group/${kind}/${group_id}/${sub_group_id}/pdf?${query}`, { responseType: 'blob' })
    },

    async getGroupActivityQuizMatrixData({ group_id, sub_group_id, course_id=0, lesson_id=0}) {
        return await axios.get(`/activity/group/quiz-matrix/${group_id}/${sub_group_id}?course_id=${course_id}&lesson_id=${lesson_id}`)
    },

    async getGroupActivityCoursesProgressionData({ group_id, sub_group_id }) {
        return await axios.get(`/activity/group/courses/${group_id}/${sub_group_id}`)
    },

    async getGroupStatisticsQuizzesData({ group_id, sub_group_id }) {
        return await axios.get(`/statistics/group/quizzes/${group_id}/${sub_group_id}`)
    },

    async getUserAssignmentsBehindForGroup({ group_id }) {
        return await axios.get(`/statistics/group/assignments-behind/${group_id}`)
    },

    async getGroupActivityLessonsProgressionData({ group_id, course_id }) {
        return await axios.get(`/activity/group/${group_id}/courses/${course_id}/lessons`)

    },

    async getGroupActivityElementsProgressionData({ group_id, lesson_id }) {
        return await axios.get(`/activity/group/${group_id}/lessons/${lesson_id}/elements`)

    },


}
